import styled from '@emotion/styled'

import { FormControlLabel } from '@mui/material'

export default styled(FormControlLabel)`
  height: 40px;
`
